/**
 * Client für api/finance.js (Bank-/PayPal-Verbindungen, Synchronisation).
 */
import { getAccessToken } from '@/api/adapters/SupabaseAdapter';

async function call(action, payload = {}) {
  const token = await getAccessToken();
  const r = await fetch('/api/finance', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
    body: JSON.stringify({ action, ...payload }),
  });
  const data = await r.json().catch(() => ({}));
  if (r.status === 404 && !data.error) {
    const err = new Error('Server-Funktion nicht erreichbar (lokal nur mit „npx vercel dev“).');
    err.code = 'API_NICHT_ERREICHBAR';
    throw err;
  }
  if (!r.ok) {
    const err = new Error(data.error || `Fehler (HTTP ${r.status})`);
    err.status = r.status;
    throw err;
  }
  return data;
}

export const financeStatus = () => call('status');
/** force=false: respektiert das Mindestintervall (Seitenaufruf) */
export const financeSync = ({ connectionId, force = true } = {}) => call('sync', { connectionId, force });
export const ebStart = (aspspName) => call('eb.start', { aspspName });
export const ebCallback = (code, state) => call('eb.callback', { code, state });
export const ebDisconnect = (connectionId) => call('eb.disconnect', { connectionId });

const DAY = 86400000;

/** Restlaufzeit der Bankfreigabe → { days, level: 'ok'|'warn'|'expired'|null } */
export function consentState(validUntil, now = new Date()) {
  if (!validUntil) return { days: null, level: null };
  const days = Math.floor((new Date(validUntil).getTime() - now.getTime()) / DAY);
  if (days < 0) return { days, level: 'expired' };
  return { days, level: days <= 14 ? 'warn' : 'ok' };
}

/** Kurztext für das Ergebnis eines Sync-Laufs */
export function syncSummary(result) {
  const rows = result?.results || [];
  const imported = rows.reduce((s, r) => s + (r.imported || 0), 0);
  const errors = rows.filter((r) => r.status === 'fehler' || r.status === 'abgelaufen');
  const parts = [`${imported} neu`];
  if (result?.autoMatched) parts.push(`${result.autoMatched} automatisch gebucht`);
  if (errors.length) parts.push(`${errors.length} Fehler`);
  return { text: parts.join(' · '), imported, autoMatched: result?.autoMatched || 0, errors };
}
